import { ListDivider } from '@natera/material/lib/list'
import { Corner, Menu, type MenuController, MenuItem } from '@natera/material/lib/menu'
import { SkeletonBlock } from '~/shared/ui'
import { useUserStore } from '../model'
import { Avatar } from './avatar'

export function AccountLink({ logout }: { logout: () => void }) {
  const userInfo = useUserStore((state) => state.userInfo)

  if (!userInfo) {
    return <SkeletonBlock className="size-10 rounded-full" />
  }

  return (
    <Menu
      className="mt-2 w-[320px] shadow-[0px_3px_6px_0px_rgba(0,0,0,0.04),0px_7px_24px_0px_rgba(0,0,0,0.19)]"
      menu={
        <>
          <MenuItem className="flex items-center gap-3 py-2 whitespace-nowrap">
            <Avatar size="tiny" />
            <div className="flex flex-col">
              <span className="text-[17px] leading-6 tracking-[0.5px]">{userInfo.name}</span>
              <span className="text-text-tertiary text-sm tracking-[0.4px]">{userInfo.email}</span>
            </div>
          </MenuItem>
          <div
            role="separator"
            className="my-2"
          >
            <ListDivider />
          </div>
          <MenuItem
            materialIcon="logout"
            onClick={logout}
          >
            Logout
          </MenuItem>
        </>
      }
      corner={Corner.BOTTOM_LEFT}
    >
      {(controller: MenuController) => (
        <Avatar
          onClick={controller.toggleMenu}
          className="cursor-pointer"
        />
      )}
    </Menu>
  )
}
